export default __webpack_public_path__ + "static/media/11.001f8392.jpg";